import { fetchAnnouncement, loadedAnnouncement } from '../actions'
import { connect } from 'react-redux'
import { showAlert } from '../utils/Alert'
import AnnouncementDetail from '../components/announcement/AnnoucementDetail'

const mapStateToProps = state => {
  return {
    announcement: state.announcementReducer.announcement,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchAnnouncement: async () => {
      try {
        const payload = await fetchAnnouncement()
        dispatch(loadedAnnouncement(payload))
      } catch (error) {
        showAlert("お知らせが取得できませんでした")
      }
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AnnouncementDetail)